import type {
  TAdditionalPhoneOwner,
  TAreaOfEmployment,
  TCarAvailability,
  TCreditPurpose,
  TEducation,
  TEmployerType,
  TEmploymentType,
  TIncomeConfirmation,
  TJobType,
  TMaritalStatus,
  TNumberOfDependents,
  TPropertyTypeAvailability,
  TSeniority,
  TUnemploymentReason,
  TPeriod,
} from 'constants/dictionaries';

import { mapAutoModels, mapLocalDictionary, mapBrands } from 'shared/lib/mapDictionaries';

import type { TCreditFormIncomingDictionaries } from '../types';

export const mapDictionary = (payload: Partial<TCreditFormIncomingDictionaries>) => {
  const {
    autoModels = [],
    brands = [],
    brand,
    purposes = [],
    employmentTypes = [],
    unemploymentReasons = [],
    incomeConfirmations = [],
    seniorityTypes = [],
    jobTypes = [],
    areasOfEmployment = [],
    employerTypes = [],
    educations = [],
    maritalStatuses = [],
    numberOfDependentsTypes = [],
    additionalPhoneOwners = [],
    carAvailabilityTypes = [],
    propertyTypeAvailabilityTypes = [],
    periods = [],
  } = payload ?? {};
  const brandId = brand?.id ?? undefined;

  return {
    autoModels: mapAutoModels({ brandId }, autoModels),
    autoBrands: mapBrands(brands),
    purposes: mapLocalDictionary<TCreditPurpose>(purposes),
    employmentTypes: mapLocalDictionary<TEmploymentType>(employmentTypes),
    unemploymentReasons: mapLocalDictionary<TUnemploymentReason>(unemploymentReasons),
    incomeConfirmations: mapLocalDictionary<TIncomeConfirmation>(incomeConfirmations),
    seniorityTypes: mapLocalDictionary<TSeniority>(seniorityTypes),
    jobTypes: mapLocalDictionary<TJobType>(jobTypes),
    areasOfEmployment: mapLocalDictionary<TAreaOfEmployment>(areasOfEmployment),
    employerTypes: mapLocalDictionary<TEmployerType>(employerTypes),
    educations: mapLocalDictionary<TEducation>(educations),
    maritalStatuses: mapLocalDictionary<TMaritalStatus>(maritalStatuses),
    numberOfDependentsTypes: mapLocalDictionary<TNumberOfDependents>(numberOfDependentsTypes),
    additionalPhoneOwners: mapLocalDictionary<TAdditionalPhoneOwner>(additionalPhoneOwners),
    carAvailabilityTypes: mapLocalDictionary<TCarAvailability>(carAvailabilityTypes),
    propertyTypeAvailabilityTypes: mapLocalDictionary<TPropertyTypeAvailability>(propertyTypeAvailabilityTypes),
    periods: mapLocalDictionary<TPeriod>(periods),
  };
};
